import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer, ViewChild} from '@angular/core';
import {ROUTES} from '../../sidebar/sidebar.component';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {UtilConfig} from "../../../autenticacion/servicios/UtilConfig";
import {AuthService} from "../../../autenticacion/servicios/auth.service";
import {ConsumerService} from "../../recursos/servicio/consumer.service";
import {WebServices} from "../../recursos/modelo/consumerModel/web-services.enum";
import {SpeechTextService} from "../../recursos/servicio/speech-text.service";
import {DEFAULT_INTERRUPTSOURCES, Idle} from "@ng-idle/core";
import {CustomUrlSerializer} from "../../recursos/modelo/UrlSerializer/custom-url-serializer";
import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import {Keepalive} from "@ng-idle/keepalive";
import {LayoutService} from "../../recursos/servicio/layout.service";
import {Usuario} from "../../content/seguridad/usuario/recursos/modelo/usuario";


const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-navbar-cmp',
    templateUrl: './../navbar/navbar.component.html',
    providers: [ConsumerService, SpeechTextService]
})

export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
    loading: boolean = false;
    location: Location;
    notificacionesNew;
    notificaciones: any = [];
    @ViewChild('app-navbar-cmp') button: any;
    timer: any;
    isIdle: boolean = false;
    public idleState = 'Not started.';
    private stompClient;
    private listTitles: any[];
    private nativeElement: Node;
    private toggleButton: any;
    private sidebarVisible: boolean;
    private timedOut = false;

    private idleEndCount = 0;
    private idleStartCount = 0;
    private idleTimeoutCount = 0;
    private idleTimeoutWarningCount = 0;


    public colorIcons = 'black';
    public origenAuthentition = 'web';
    public colorTitle = null;


    constructor(private util: UtilConfig,
                location: Location,
                private layout: LayoutService,
                public jwtUtil: UtilConfig,
                private consumer: ConsumerService,
                private speechTextService: SpeechTextService,
                private authService: AuthService,
                private renderer: Renderer,
                private element: ElementRef,
                private router: Router,
                private idle: Idle,
                private keepalive: Keepalive) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
        this.origenAuthentition = sessionStorage.getItem('origen');
        this.idle.setIdle(540);
        this.idle.setTimeout(60);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleEnd.subscribe(() => {
            this.idleEndCount++;
            this.idleState = 'Se encontro actividad en la pantalla.';
            this.isIdle = false;
            this.consumer.update(WebServices.URL_REFRESCAR_TOKEN, {token: this.jwtUtil.getJwtToken()}).subscribe(resp => {
                this.jwtUtil.setJwtToken(resp.token);
            });
        });

        
        jwtUtil.showComunicationMessage();

        idle.onTimeout.subscribe(() => {
            this.idleTimeoutCount++;
            //this.speechTextService.voiceSpeech(" La sesión se ha cerrado.");
            this.logout();
            this.timedOut = true;
        });

        idle.onIdleStart.subscribe(() => {
            this.idleStartCount++;
            this.idleState = 'You\'ve gone idle!'
        });

        idle.onTimeoutWarning.subscribe((countdown) => {
            this.isIdle = true;
            this.idleTimeoutWarningCount++;
            //if(countdown == 9)
            //    this.speechTextService.voiceSpeech(this.util.getCurrentUser().nombres.split(" ")[0] + " la sesión se cerrara pronto: ");

            this.idleState = 'Se ha detectado inactividad en la pantalla, quedan ' + countdown + ' segundos!'

        });

        keepalive.interval(400);

        keepalive.onPing.subscribe(() => {
            this.consumer.update(WebServices.URL_REFRESCAR_TOKEN, {token: this.jwtUtil.getJwtToken()}).subscribe(resp => {
                this.jwtUtil.setJwtToken(resp.token);
            });
        });


        this.layout.getColorIcons().subscribe(colorIcons => {
            this.colorIcons = colorIcons;
        });
        this.layout.getColorTitle().subscribe(colorTitle => {
            this.colorTitle = colorTitle;
        });

        this.reset();

    }

    ngOnDestroy() {
        this.idle.stop();
        this.timer = null;
    }

    reset() {
        this.idle.watch();
        this.idleState = '';
        this.timedOut = false;
    }

    ngOnInit() {

        //this.obtenerNotificaciones(true);
        this.listTitles = ROUTES.filter(listTitle => listTitle);

        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        if ($('body').hasClass('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if ($('body').hasClass('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        $('#minimizeSidebar').click(function () {
            if (misc.sidebar_mini_active === true) {
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;

            } else {
                setTimeout(function () {
                    $('body').addClass('sidebar-mini');

                    misc.sidebar_mini_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            const simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);
        });
        $('#hideSidebar').click(function () {
            if (misc.hide_sidebar_active === true) {
                setTimeout(function () {
                    $('body').removeClass('hide-sidebar');
                    misc.hide_sidebar_active = false;
                }, 300);
                setTimeout(function () {
                    $('.sidebar').removeClass('animation');
                }, 600);
                $('.sidebar').addClass('animation');

            } else {
                setTimeout(function () {
                    $('body').addClass('hide-sidebar');
                    // $('.sidebar').addClass('animation');
                    misc.hide_sidebar_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            const simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);
        });

        var mainPanel = document.getElementsByClassName('main-panel')[0];
        $('.modal').on('shown.bs.modal', function () {
            mainPanel.classList.add('no-scroll');
        });
        $('.modal').on('hidden.bs.modal', function () {
            mainPanel.classList.remove('no-scroll');
        });

        this.stompConnect();
    }

    onResize(event) {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    toggleSidebar() {

    }

    sidebarOpen() {
        $('body').addClass('sidebar-mini');
        this.sidebarVisible = true;
    };

    sidebarClose() {
        $('body').removeClass('sidebar-mini');
        this.sidebarVisible = false;
    };

    sidebarToggle() {
        if (!this.sidebarVisible) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };

    getTitle() {
        var title = "Home";
        var titlee = this.location.prepareExternalUrl(CustomUrlSerializer.decript(this.location.path()));
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(2);
        }


        $.each(this.listTitles, (pos, item) => {
            if (item.title != null) {
                if (titlee.indexOf(item.path) != -1) {
                    title = item.title;
                }
            }
        });

        for (var item = 0; item < this.listTitles.length; item++) {
            $.each(this.listTitles[item].children, (pos, itemChildren) => {
                if (titlee.indexOf(itemChildren.path) != -1) {
                    title = this.listTitles[item].title + " > " + itemChildren.title;
                }
                if (titlee.indexOf("detallePerfil") != -1 || titlee.indexOf("miPerfil") != -1) {
                    title = "Mi perfil";
                }
                if (titlee.indexOf("perfilCustomer") != -1) {
                    title = "Mi empresa";
                }
            });
        }
        return title;
    }

    getIcon() {
        var title = "home";
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(2);
        }

        $.each(this.listTitles, (pos, item) => {
            if (item.title != null) {
                if (titlee.indexOf(item.path) != -1) {
                    title = item.icontype;
                }
            }
        });

        for (var item = 0; item < this.listTitles.length; item++) {
            $.each(this.listTitles[item].children, (pos, itemChildren) => {
                if (titlee.indexOf(itemChildren.path) != -1) {
                    title = itemChildren.icontype;
                }
                if (titlee.indexOf("detallePerfil") != -1 || titlee.indexOf("miPerfil") != -1) {
                    title = "account_box";
                }
                if (titlee.indexOf("perfilCustomer") != -1) {
                    title = "business";
                }
            });
        }
        return title;
    }

    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }

    logout(): void {
        // LLAMADO AL SERVICIO
        this.loading = true;
        this.consumer.create(WebServices.URL_LOGOUT).subscribe((result) => {
            const usuario = this.jwtUtil.getCurrentUser();
            if (usuario.customer.authenticationType === 'AZURE_AD') {
                this.jwtUtil.removeJwtToken();
                this.jwtUtil.removeCurrentUser();
                this.authService.logout();
                this.router.navigate(['/loginAzure']);
            } else {
                this.jwtUtil.removeJwtToken();
                this.jwtUtil.removeCurrentUser();
                this.authService.logout();
                this.router.navigate(['/']);
            }

        }, err => {
            const usuario = this.jwtUtil.getCurrentUser();

            if (usuario.customer.authenticationType === 'AZURE_AD') {
                this.jwtUtil.removeJwtToken();
                this.jwtUtil.removeCurrentUser();
                this.authService.logout();
                this.router.navigate(['/loginAzure']);
            } else {
                this.jwtUtil.removeJwtToken();
                this.jwtUtil.removeCurrentUser();
                this.authService.logout();
                this.router.navigate(['/']);
            }
        });
        swal.close();
    }


    lockScreen(): void {
        // LLAMADO AL SERVICIO

        this.authService.lockScreen(window.location.href);
        this.router.navigate(['/lock']);
    }

    obtenerNotificaciones(activarBienvenida) {
        // LLAMADO AL SERVICIO
        this.consumer.post<any>(WebServices.URL_GET_NOTIFICATION)
            .subscribe((result) => {
                this.notificaciones = result["notificaciones"];
                this.notificacionesNew = 0;
                if (this.notificaciones)
                    $.each(this.notificaciones, (pos, item) => {
                        if (item.estatus == 'PENDIENTE') {
                            this.notificacionesNew++;
                        }
                    });
                if (true) {
                    if (activarBienvenida)
                        this.speechTextService.voiceSpeech("Bienvenido " + this.util.getCurrentUser().nombres.split(" ")[0]);

                    if (this.notificacionesNew > 0) {
                        if (this.notificacionesNew == 1) {
                            this.speechTextService.voiceSpeech(", Tienes un mensajes sin leer.");
                        } else {
                            this.speechTextService.voiceSpeech(", Tienes " + this.notificacionesNew + " mensajes sin leer.");
                        }
                    } else {
                        if (activarBienvenida)
                            this.speechTextService.voiceSpeech("No tienes mensajes pendientes.");
                    }
                }
            }, err => {
            });
    }

    actualizarNotificaciones(): void {
        this.consumer.update(WebServices.URL_ACTUALIZAR_NOTIFICATION, {notificaciones: this.notificaciones})
            .subscribe(result => {
                this.notificaciones = result;
                this.notificacionesNew = 0;
                $.each(this.notificaciones, (pos, item) => {
                    if (item.estatus == 'PENDIENTE') {
                        this.notificacionesNew++;
                    }
                });
            }, err => {
            });
    }


    ngAfterViewInit() {
        // se activa al segundo de ser creado y luego intervalos de 1 minuto
        // this.timer = Observable.timer(100000, 500000);
        // let subscription = this.timer.subscribe(x => this.obtenerNotificaciones(false));
    }

    stompConnect() {
        let socket = new SockJS(this.jwtUtil.URL_WS_BACKEND + '/realTime');
        this.stompClient = Stomp.over(socket);
        this.stompClient.debug = null;
        this.stompClient.connect({}, (frame) => {
            this.stompClient.subscribe('/topicSession', (user) => {
                let usuario = JSON.parse(user.body);
                let tokenSession = this.jwtUtil.getJwtToken();
                let current = this.jwtUtil.getCurrentUser();
                if (usuario.username === current.username && tokenSession != null && current.fechaUltimoIngreso != usuario.fechaUltimoIngreso) {

                    this.logout();
                    swal(
                        'Importante!',
                        'El usuario se ha autenticado desde otro lugar. Se ha cerrado esta sessión.',
                        'warning'
                    );
                }

            });
        });
    }

    stompDisconnect() {
        if (this.stompClient !== null) {
            this.stompClient.disconnect();
        }
    }

    cambiarClave(): void {
        // LLAMADO AL SERVICIO
        this.router.navigate(['/resetClave']);
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/shared/navbar/navbar.component.ts